<template>
  <div class="modal-overlay" @click.self="$emit('close-modal')">
    <div class="modal">
      <button class="close-button" @click="$emit('close-modal')">✕</button>
      <h6>{{ textoTituloFatura }}</h6>
      <p class="small-text">{{ textoDescricao }}</p>

      <div class="search-bar-container">
        <input
          v-model="searchQuery"
          @input="filterFaturas"
          type="text"
          placeholder="Digite CNPJ, Transportador ou Valor..."
          class="search-bar"
        />
      </div>

      <div class="modal-totals">
        <p>Total de faturas pendentes: {{ pendingCount }}</p>
        <p>Valor total: {{ formatCurrency(pendingTotal) }}</p>
      </div>

      <!-- Botão de filtro de período acima da tabela -->
      <div class="filter-button-container">
        <button @click="showDateFilterModal" class="filter-button">
          Filtrar por Período
        </button>
      </div>

      <div class="content-container">
        <table class="faturas-table desktop-only">
          <thead>
            <tr>
              <th @click="sortTable('cnpj')" style="cursor: pointer;">
                CNPJ
                <span class="sort-arrow" :class="{ active: currentSortColumn === 'cnpj' }">
                  {{ currentSortColumn === 'cnpj' ? (currentSortDirection === 'asc' ? '↑' : '↓') : '↕' }}
                </span>
              </th>
              <th @click="sortTable('transportador')" style="cursor: pointer;">
                Transportador
                <span class="sort-arrow" :class="{ active: currentSortColumn === 'transportador' }">
                  {{ currentSortColumn === 'transportador' ? (currentSortDirection === 'asc' ? '↑' : '↓') : '↕' }}
                </span>
              </th>
              <th>Baixar</th>
              <th>PIX</th>
              <th>Boleto</th>
              <th>QR Code Pix</th>
              <th @click="sortTable('referencia')" style="cursor: pointer;">
                Referência
                <span class="sort-arrow" :class="{ active: currentSortColumn === 'referencia' }">
                  {{ currentSortColumn === 'referencia' ? (currentSortDirection === 'asc' ? '↑' : '↓') : '↕' }}
                </span>
              </th>
              <th @click="sortTable('qtde')" style="cursor: pointer;">
                Qtd CTEs
                <span class="sort-arrow" :class="{ active: currentSortColumn === 'qtde' }">
                  {{ currentSortColumn === 'qtde' ? (currentSortDirection === 'asc' ? '↑' : '↓') : '↕' }}
                </span>
              </th>
              <th @click="sortTable('valor')" style="cursor: pointer;">
                Valor
                <span class="sort-arrow" :class="{ active: currentSortColumn === 'valor' }">
                  {{ currentSortColumn === 'valor' ? (currentSortDirection === 'asc' ? '↑' : '↓') : '↕' }}
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(fatura, index) in sortedFaturas" :key="index">
              <td>{{ fatura.transportador.cnpj }}</td>
              <td>{{ fatura.transportador.nomeFantasia }}</td>
              <td><a @click.prevent="downloadPDF(fatura.linkFatura)" href="#">PDF</a></td>
              <td><a @click.prevent="copiarPix(fatura.codigoPix)" href="#">PIX</a></td>
              <td>
                <a @click.prevent="downloadBoleto(fatura.caminhoBoleto)" href="#" v-if="fatura.caminhoBoleto">Boleto</a>
                <span v-else> </span>
              </td>
              <td><a @click.prevent="showQRCodeModal(fatura.codigoPix)" href="#">QrCodePix</a></td>
              <td>{{ fatura.mes }} / {{ fatura.ano }}</td>
              <td>{{ fatura.qtde }}</td>
              <td class="valor">{{ formatCurrency(fatura.valorTotal) }}</td>
            </tr>
          </tbody>
        </table>

        <div class="faturas-cards mobile-only">
          <div v-for="(fatura, index) in sortedFaturas" :key="index" class="fatura-card">
            <div class="card-header">
              <h3>{{ fatura.transportador.nomeFantasia }}</h3>
              <span>{{ formatCurrency(fatura.valorTotal) }}</span>
            </div>
            <div class="card-body">
              <p><strong>CNPJ:</strong> {{ fatura.transportador.cnpj }}</p>
              <p><strong>Referência:</strong> {{ fatura.mes }} / {{ fatura.ano }}</p>
              <p><strong>Qtd CTEs:</strong> {{ fatura.qtde }}</p>
            </div>
            <div class="card-actions">
              <button @click="downloadPDF(fatura.linkFatura)">Baixar PDF</button>
              <button @click="copiarPix(fatura.codigoPix)">Copiar PIX</button>
              <button @click="downloadBoleto(fatura.caminhoBoleto)" v-if="fatura.caminhoBoleto">Baixar Boleto</button>
              <button @click="showQRCodeModal(fatura.codigoPix)">QR Code</button>
            </div>
          </div>
        </div>
      </div>

      <div class="fixed-footer">
        <a :href="linkWhatsApp" class="whats-link">
          <img src="https://ik.imagekit.io/d6rcr6hta/whatsapp.png?updatedAt=1730644409968" alt="WhatsApp" class="whats-icon" />
          Whatsapp {{ foneCobranca.ddd }}{{ foneCobranca.numero }}
        </a>
        <button @click="$emit('close-modal')" class="confirm-button">OK</button>
      </div>

      <div v-if="qrCodeModalVisible" class="qr-code-modal-overlay" @click.self="qrCodeModalVisible = false">
        <div class="qr-code-modal">
          <img :src="largeQRCode" alt="QR Code Pix" class="qr-code-image" />
          <button @click="qrCodeModalVisible = false" class="close-button-below">Fechar</button>
        </div>
      </div>

      <div v-if="dateFilterModalVisible" class="date-filter-modal-overlay" @click.self="dateFilterModalVisible = false">
        <div class="date-filter-modal">
          <h6>Filtrar por Período</h6>
          <div class="date-filter-container">
            <div class="date-picker">
              <label>Início:</label>
              <select v-model="startMonth">
                <option value="">Mês</option>
                <option v-for="(month, index) in months" :key="index + 1" :value="index + 1">{{ month }}</option>
              </select>
              <select v-model="startYear">
                <option value="">Ano</option>
                <option v-for="year in availableYears" :key="year" :value="year">{{ year }}</option>
              </select>
            </div>
            <div class="date-picker">
              <label>Fim:</label>
              <select v-model="endMonth">
                <option value="">Mês</option>
                <option v-for="(month, index) in months" :key="index + 1" :value="index + 1">{{ month }}</option>
              </select>
              <select v-model="endYear">
                <option value="">Ano</option>
                <option v-for="year in availableYears" :key="year" :value="year">{{ year }}</option>
              </select>
            </div>
          </div>
          <div class="date-filter-actions">
            <button @click="applyDateFilter" class="apply-button">Aplicar</button>
            <button @click="dateFilterModalVisible = false" class="cancel-button">Cancelar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Movimentacao from "../service/movimentacao";
import { httpCadastro } from "../plugins/http";
import Fatura from "../service/fatura";
import QRCode from "qrcode";
import { mapActions } from "vuex";

export default {
  props: {
    fraseFatPend: String,
  },
  data() {
    return {
      texto: this.fraseFatPend,
      faturas: [],
      filteredFaturas: [],
      searchQuery: "",
      foneCobranca: "",
      linkWhatsApp: "",
      textoTituloFatura: "Faturas Pendentes",
      textoDescricao:
        "Faturas vencidas há mais de 3 dias resultarão na suspensão da emissão de novos documentos.",
      qrCodeModalVisible: false,
      currentQRCode: "",
      largeQRCode: "",
      currentSortColumn: "",
      currentSortDirection: "asc",
      dateFilterModalVisible: false,
      startMonth: "",
      startYear: "",
      endMonth: "",
      endYear: "",
      months: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ],
    };
  },
  mounted() {
    Movimentacao.getAllFaturas().then((response) => {
      var faturasPendentes = response.data;
      if (
        faturasPendentes.transportadores &&
        faturasPendentes.transportadores.length > 0
      ) {
        this.mostrarFaturasPendentes(faturasPendentes);
      } else {
        this.$emit("semFaturas");
      }
    });
  },
  computed: {
    sortedFaturas() {
      let faturas = [...this.filteredFaturas];
      if (this.currentSortColumn) {
        faturas.sort((a, b) => {
          let aVal, bVal;
          switch (this.currentSortColumn) {
            case "cnpj":
              aVal = a.transportador.cnpj;
              bVal = b.transportador.cnpj;
              break;
            case "transportador":
              aVal = a.transportador.nomeFantasia;
              bVal = b.transportador.nomeFantasia;
              break;
            case "referencia":
              aVal = a.ano * 100 + a.mes;
              bVal = b.ano * 100 + b.mes;
              break;
            case "qtde":
              aVal = a.qtde;
              bVal = b.qtde;
              break;
            case "valor":
              aVal = a.valorTotal;
              bVal = b.valorTotal;
              break;
            default:
              aVal = "";
              bVal = "";
          }
          if (typeof aVal === "string" && typeof bVal === "string") {
            aVal = aVal.toLowerCase();
            bVal = bVal.toLowerCase();
            if (aVal < bVal) return this.currentSortDirection === "asc" ? -1 : 1;
            if (aVal > bVal) return this.currentSortDirection === "asc" ? 1 : -1;
            return 0;
          } else {
            return this.currentSortDirection === "asc" ? aVal - bVal : bVal - aVal;
          }
        });
      }
      return faturas;
    },
    pendingCount() {
      return this.filteredFaturas.length;
    },
    pendingTotal() {
      return this.filteredFaturas.reduce(
        (total, fatura) => total + fatura.valorTotal,
        0
      );
    },
    availableYears() {
      const currentYear = new Date().getFullYear();
      const years = [];
      for (let i = currentYear - 5; i <= currentYear + 1; i++) {
        years.push(i);
      }
      return years;
    },
  },
  methods: {
    ...mapActions(["snackSuccess", "snackError"]),
    mostrarFaturasPendentes(faturasPendentes) {
      var faturasPendentesAjustadas = [];
      var temVencido = false;

      for (var i = 0; i < faturasPendentes.transportadores.length; i++) {
        var transportador = faturasPendentes.transportadores[i];

        for (var j = 0; j < transportador.debitos.length; j++) {
          var debito = transportador.debitos[j];
          debito.transportador = transportador;

          debito.linkFatura = Fatura.urlFaturaPdf(debito.transportador.cnpj, debito.ano, debito.mes);

          faturasPendentesAjustadas.push(debito);

          this.foneCobranca = faturasPendentes.foneCobranca;
          this.linkWhatsApp = `https://api.whatsapp.com/send?phone=${this.foneCobranca.ddd}${this.foneCobranca.numero}`;

          if (debito.status === "VENCIDO") temVencido = true;
        }
      }

      this.faturas = faturasPendentesAjustadas;
      // Inicialmente, o filtro é aplicado sobre todas as faturas
      this.filteredFaturas = faturasPendentesAjustadas;
      this.texto =
        faturasPendentesAjustadas.length === 1
          ? "Há uma fatura pendente de pagamento"
          : `Há ${faturasPendentesAjustadas.length} faturas pendentes de pagamento`;

      if (temVencido) {
        this.$emit("show-modal");
      } else {
        this.textoTituloFatura =
          faturasPendentesAjustadas.length === 1
            ? "Fatura em aberto"
            : "Faturas em aberto";
        this.textoDescricao =
          "Há faturas em aberto, mas ainda dentro do prazo";
      }
    },
    filterFaturas() {
      const query = this.searchQuery.toLowerCase();
      let list = this.faturas;

      // Se tiver filtro de data aplicado, filtra primeiro pela referência (ano e mês)
      if (this.startYear || this.endYear) {
        const startMonth = this.startMonth || 1;
        const endMonth = this.endMonth || 12;
        const startDate = this.startYear
          ? parseInt(this.startYear) * 100 + parseInt(startMonth)
          : -Infinity;
        const endDate = this.endYear
          ? parseInt(this.endYear) * 100 + parseInt(endMonth)
          : Infinity;

        list = list.filter((fatura) => {
          const faturaDate = fatura.ano * 100 + fatura.mes;
          return faturaDate >= startDate && faturaDate <= endDate;
        });
      }

      if (!query) {
        this.filteredFaturas = list;
      } else {
        this.filteredFaturas = list.filter((fatura) => {
          const cnpjMatch = fatura.transportador.cnpj.toLowerCase().includes(query);
          const transportadorMatch = fatura.transportador.nomeFantasia.toLowerCase().includes(query);
          const valorMatch = this.formatCurrency(fatura.valorTotal).toLowerCase().includes(query);
          return cnpjMatch || transportadorMatch || valorMatch;
        });
      }
    },
    async downloadPDF(url) {
      const pdfUrl = url;
      const authToken = localStorage.getItem("token");

      try {
        const headers = new Headers();
        headers.append("Authorization", `Bearer ${authToken}`);
        const response = await fetch(pdfUrl, { headers });
        const blob = await response.blob();
        const urlBlob = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = urlBlob;
        link.setAttribute("download", "fatura.pdf");
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();

        window.URL.revokeObjectURL(urlBlob);
        document.body.removeChild(link);
      } catch (error) {
        console.error("Erro ao baixar o PDF:", error);
      }
    },
    async downloadBoleto(caminho) {
      try {
        // httpCadastro em vez de fetch: o Authorization passa a vir do
        // interceptor, junto com o tratamento de 401.
        const response = await httpCadastro.get(
          "/v1/cadastro/participante/recupera-boleto",
          { params: { caminho }, responseType: "blob" }
        );

        const urlBlob = window.URL.createObjectURL(new Blob([response.data]));

        const link = document.createElement("a");
        link.href = urlBlob;
        link.setAttribute("download", "boleto.pdf");
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();

        window.URL.revokeObjectURL(urlBlob);
        document.body.removeChild(link);
      } catch (error) {
        console.error("Erro ao baixar o boleto:", error);
        this.snackError("Falha ao baixar o boleto");
      }
    },
    copiarPix(conteudo) {
      var input = document.createElement("input");
      input.setAttribute("value", conteudo);
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      this.snackSuccess("Código PIX copiado");
    },
    async generateQRCode(pixCode, size = 100) {
      try {
        return await QRCode.toDataURL(pixCode, { width: size });
      } catch (error) {
        console.error("Erro ao gerar QR Code:", error);
      }
    },
    async showQRCodeModal(pixCode) {
      this.largeQRCode = await this.generateQRCode(pixCode, 600);
      this.qrCodeModalVisible = true;
    },
    sortTable(columnKey) {
      if (this.currentSortColumn === columnKey) {
        this.currentSortDirection =
          this.currentSortDirection === "asc" ? "desc" : "asc";
      } else {
        this.currentSortColumn = columnKey;
        this.currentSortDirection = "asc";
      }
    },
    formatCurrency(value) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
    showDateFilterModal() {
      this.dateFilterModalVisible = true;
    },
    applyDateFilter() {
      if (!this.startYear && !this.endYear) {
        this.snackError("Por favor, selecione pelo menos o ano de início e fim.");
        return;
      }
      // Apenas chama o filterFaturas que agora já aplica o filtro de data junto com a busca
      this.filterFaturas();
      this.dateFilterModalVisible = false;
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1000;
}

.modal {
  position: relative;
  background-color: #fff;
  padding: 20px;
  width: 90%;
  max-width: 1400px;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  max-height: 80vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.close-button {
  position: absolute;
  top: 15px;
  right: 15px;
  font-size: 1.5rem;
  background: none;
  border: none;
  color: #555;
  cursor: pointer;
}

.search-bar-container {
  margin-bottom: 2px;
}

.search-bar {
  padding: 0.5rem;
  border-radius: 0.25rem;
  border: 1px solid #ddd;
  width: 100%;
  max-width: 90%px;
  box-sizing: border-box;
}

.modal-totals {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  color: #333;
}

.filter-button-container {
  margin-bottom: 10px;
  text-align: right;
}

.filter-button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.filter-button:hover {
  background-color: #0056b3;
}

.content-container {
  flex: 1;
  overflow-y: auto;
}

.faturas-table {
  width: 100%;
  border-collapse: collapse;
}

.faturas-table th,
.faturas-table td {
  padding: 10px;
  border: 1px solid #ddd;
  text-align: center;
}

.faturas-table th {
  position: sticky;
  top: 0;
  background-color: #007bff;
  color: #fff;
  font-weight: bold;
  z-index: 1;
}

.faturas-table .valor {
  text-align: right;
  padding-right: 10px;
}

.faturas-cards {
  display: none;
  flex-direction: column;
  gap: 12px;
}

.fatura-card {
  background-color: #f5f1f1d5;
  border-radius: 8px;
  padding: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  align-items: baseline;
  border: 1px solid #007bff;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.card-header h3 {
  font-size: 15px;
  margin: 0;
  color: #333;
}

.card-header span {
  font-size: 1.0rem;
  font-weight: bold;
  color: #007bff;
}

.card-body p {
  margin: 5px 0;
  font-size: 0.9rem;
  color: #555;
}

.card-actions {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.card-actions button {
  size: 10px;
  flex: 1;
  padding: 3px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
}

.card-actions button:hover {
  background-color: #0056b3;
}

.fixed-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-top: 1px solid #ddd;
  background-color: #f9f9f9;
  width: 100%;
}

.whats-link {
  display: flex;
  align-items: center;
  color: #007bff;
  font-weight: bold;
  text-decoration: none;
}

.whats-icon {
  width: 20px;
  margin-right: 5px;
}

.confirm-button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
}

.confirm-button:hover {
  background-color: #0056b3;
}

.qr-code-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.qr-code-modal {
  background-color: #fff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  width: 400px;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.qr-code-image {
  width: 300px;
}

.close-button-below {
  margin-top: 50px;
  padding: 10px 20px;
  font-size: 1rem;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.date-filter-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.date-filter-modal {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  width: 100%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  box-sizing: border-box;
}

.date-filter-container {
  display: flex;
  gap: 10px;
}

.date-picker {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1 100%;
}

.date-picker label {
  font-size: 14px;
  color: #333;
  margin-right: 5px;
}

.date-picker select {
  padding: 8px;
  height: 40px;
  border-radius: 4px;
  border: 1px solid #ddd;
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24'%3E%3Cpath fill='%23333' d='M7 10l5 5 5-5z'/%3E%3C/svg%3E") no-repeat right 10px center;
  background-size: 16px;
  appearance: none;
  min-width: 0;
}

.date-picker select:nth-child(2) {
  width: 120px;
}

.date-picker select:nth-child(3) {
  width: 80px;
}

.date-filter-actions {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.apply-button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.apply-button:hover {
  background-color: #0056b3;
}

.cancel-button {
  background-color: #ccc;
  color: #333;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.cancel-button:hover {
  background-color: #bbb;
}

h6 {
  font-weight: 600;
  font-size: 24px;
  color: #333;
  margin-top: 0;
  margin-bottom: 10px;
}

p {
  font-size: 12px;
  margin: 5px 0 10px;
  color: #007bff;
}

.small-text {
  font-size: 12px;
  margin: 10px 0 10px;
  color: #555;
}

@media (max-width: 768px) {
  .desktop-only {
    display: none;
  }
  .faturas-cards {
    display: flex;
  }
  .modal {
    width: 100%;
  }
  .date-filter-modal {
    width: 90%;
    max-width: 350px;
  }
  .date-picker {
    flex-direction: column;
    align-items: flex-start;
  }
  .date-picker select {
    width: 100%;
    max-width: none;
  }
}

@media (min-width: 769px) {
  .desktop-only {
    display: table;
  }
  .mobile-only {
    display: none;
  }
  .date-picker {
    flex: 0 1 auto;
  }
}
</style>
